var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCbHidden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 385.86,
    height: 43.561,
    viewBox: "0 0 385.86 43.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5123",
    "data-name": "Group 5123",
    transform: "translate(-662.43 -452.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8675",
    "data-name": "Path 8675",
    d: "M-135.1-19.635l4.865-1.645.735,2.345-4.865,1.575,3.08,4.165-1.925,1.435-3.185-4.27-3.115,4.2-1.925-1.435,3.115-4.1-4.97-1.68.735-2.275,4.935,1.68V-24.78h2.52Zm16.24,0,4.865-1.645.735,2.345-4.865,1.575,3.08,4.165-1.925,1.435-3.185-4.27-3.115,4.2-1.925-1.435,3.115-4.1-4.97-1.68.735-2.275,4.935,1.68V-24.78h2.52Zm16.24,0,4.865-1.645.735,2.345-4.865,1.575,3.08,4.165-1.925,1.435-3.185-4.27-3.115,4.2-1.925-1.435,3.115-4.1-4.97-1.68.735-2.275,4.935,1.68V-24.78h2.52Zm16.24,0,4.865-1.645.735,2.345-4.865,1.575,3.08,4.165L-84.49-11.76l-3.185-4.27-3.115,4.2-1.925-1.435,3.115-4.1-4.97-1.68.735-2.275,4.935,1.68V-24.78h2.52Zm25.97,0,4.865-1.645.735,2.345-4.865,1.575,3.08,4.165L-58.52-11.76-61.7-16.03l-3.115,4.2-1.925-1.435,3.115-4.1-4.97-1.68.735-2.275,4.935,1.68V-24.78h2.52Zm16.24,0,4.865-1.645.735,2.345-4.865,1.575,3.08,4.165L-42.28-11.76l-3.185-4.27-3.115,4.2L-50.5-13.265l3.115-4.1-4.97-1.68.735-2.275,4.935,1.68V-24.78h2.52Zm16.24,0,4.865-1.645.735,2.345L-27.2-17.36l3.08,4.165L-26.04-11.76l-3.185-4.27-3.115,4.2-1.925-1.435,3.115-4.1-4.97-1.68.735-2.275,4.935,1.68V-24.78h2.52Zm16.24,0,4.865-1.645.735,2.345-4.865,1.575,3.08,4.165L-9.8-11.76l-3.185-4.27-3.115,4.2-1.925-1.435,3.115-4.1-4.97-1.68.735-2.275,4.935,1.68V-24.78h2.52Zm25.97,0,4.865-1.645.735,2.345L15.015-17.36l3.08,4.165L16.17-11.76l-3.185-4.27L9.87-11.83,7.945-13.265l3.115-4.1L6.09-19.04l.735-2.275,4.935,1.68V-24.78h2.52Zm16.24,0,4.865-1.645.735,2.345L31.255-17.36l3.08,4.165L32.41-11.76l-3.185-4.27-3.115,4.2-1.925-1.435,3.115-4.1-4.97-1.68.735-2.275L28-19.635V-24.78h2.52Zm16.24,0,4.865-1.645.735,2.345L47.5-17.36l3.08,4.165L48.65-11.76l-3.185-4.27-3.115,4.2-1.925-1.435,3.115-4.1-4.97-1.68.735-2.275,4.935,1.68V-24.78h2.52Zm16.24,0,4.865-1.645.735,2.345L63.735-17.36l3.08,4.165L64.89-11.76l-3.185-4.27-3.115,4.2-1.925-1.435,3.115-4.1-4.97-1.68.735-2.275,4.935,1.68V-24.78H63Zm25.97,0,4.865-1.645.735,2.345L89.705-17.36l3.08,4.165L90.86-11.76l-3.185-4.27-3.115,4.2-1.925-1.435,3.115-4.1-4.97-1.68.735-2.275,4.935,1.68V-24.78h2.52Zm16.24,0,4.865-1.645.735,2.345-4.865,1.575,3.08,4.165L107.1-11.76l-3.185-4.27-3.115,4.2-1.925-1.435,3.115-4.1-4.97-1.68.735-2.275,4.935,1.68V-24.78h2.52Zm16.24,0,4.865-1.645.735,2.345-4.865,1.575,3.08,4.165L123.34-11.76l-3.185-4.27-3.115,4.2-1.925-1.435,3.115-4.1-4.97-1.68.735-2.275,4.935,1.68V-24.78h2.52Zm16.24,0,4.865-1.645.735,2.345-4.865,1.575,3.08,4.165L139.58-11.76,136.4-16.03l-3.115,4.2-1.925-1.435,3.115-4.1-4.97-1.68.735-2.275,4.935,1.68V-24.78h2.52Z",
    transform: "translate(905 493)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "credit-card",
    transform: "translate(662.43 403.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8602",
    "data-name": "Path 8602",
    d: "M70.106,80.406l3.159-20.17a3.755,3.755,0,0,0-3.111-4.3h0L27.53,49.093a3.753,3.753,0,0,0-4.3,3.111l-1.515,9.433V80.289Z",
    transform: "translate(-19.429)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8603",
    "data-name": "Path 8603",
    d: "M112.481,97.992l-12.106-1.943C92.243,108.49,79.1,117.107,69.019,122.358l43.414.105,3.159-20.17a3.755,3.755,0,0,0-3.111-4.3Z",
    transform: "translate(-61.755 -42.057)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8604",
    "data-name": "Path 8604",
    d: "M3.754,159.771h43.17a3.754,3.754,0,0,1,3.754,3.754v24.4a3.754,3.754,0,0,1-3.754,3.754H3.754A3.754,3.754,0,0,1,0,187.925v-24.4A3.754,3.754,0,0,1,3.754,159.771Z",
    transform: "translate(0 -99.073)",
    fill: "#4398d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8605",
    "data-name": "Path 8605",
    d: "M137.506,159.771h-.751c-8.859,15.728-25.413,26.517-35.518,31.908h36.269a3.754,3.754,0,0,0,3.754-3.754v-24.4A3.754,3.754,0,0,0,137.506,159.771Z",
    transform: "translate(-90.583 -99.073)",
    fill: "#3e8cc7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1373",
    "data-name": "Rectangle 1373",
    width: 9.385,
    height: 7.508,
    transform: "translate(4.692 65.391)",
    fill: "#c3e2e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5074",
    "data-name": "Group 5074",
    transform: "translate(4.692 68.206)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1374",
    "data-name": "Rectangle 1374",
    width: 2.815,
    height: 1.877,
    transform: "translate(0 0)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1375",
    "data-name": "Rectangle 1375",
    width: 2.815,
    height: 1.877,
    transform: "translate(6.569 0)",
    fill: "#87ced9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    cx: 4.692,
    cy: 4.692,
    r: 4.692,
    transform: "translate(36.6 78.529)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_247",
    "data-name": "Ellipse 247",
    cx: 4.692,
    cy: 4.692,
    r: 4.692,
    transform: "translate(30.97 78.529)",
    fill: "#c3e2e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5075",
    "data-name": "Group 5075",
    transform: "translate(3.754 65.391)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1376",
    "data-name": "Rectangle 1376",
    width: 5.631,
    height: 1.877,
    transform: "translate(0 14.077)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1377",
    "data-name": "Rectangle 1377",
    width: 5.631,
    height: 1.877,
    transform: "translate(9.385 14.077)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1378",
    "data-name": "Rectangle 1378",
    width: 5.631,
    height: 1.877,
    transform: "translate(18.769 14.077)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1379",
    "data-name": "Rectangle 1379",
    width: 24.4,
    height: 1.877,
    transform: "translate(0 19.708)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1380",
    "data-name": "Rectangle 1380",
    width: 1.877,
    height: 3.754,
    transform: "translate(29.093 0)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1381",
    "data-name": "Rectangle 1381",
    width: 1.877,
    height: 3.754,
    transform: "translate(32.847 0)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1382",
    "data-name": "Rectangle 1382",
    width: 1.877,
    height: 3.754,
    transform: "translate(36.6 0)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1383",
    "data-name": "Rectangle 1383",
    width: 1.877,
    height: 3.754,
    transform: "translate(40.354 0)",
    fill: "#87ced9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbHidden);
export default __webpack_public_path__ + "static/media/cb_hidden.c469a86d.svg";
export { ForwardRef as ReactComponent };